<!--
  v1.0
  Composant: b122-table-pagination
 -->

<template>
  <div class="b122-pagination-container">

    <b-dropdown class="mr-4" variant="light" size="sm" right>

      <template #button-content>
        {{ firstRow }} - {{ lastRow }} {{$t('on')}} {{ totalRows }}
      </template>

      <b-dropdown-item
        v-for="perPageOption in perPageOptions"
        :key="perPageOption.value"
        :class="{'current-per-page': perPageOption.value === perPage}"
        @click="changePerPage(perPageOption.value)">
        {{perPageOption.text}}
      </b-dropdown-item>

    </b-dropdown>

    <b-pagination
      class="mb-0"
      limit="3"
      size="sm"
      :value="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      @change="changeCurrentPage">
    </b-pagination>

  </div>
</template>

<script>

export default {

  name: 'b122-table-pagination',

  props: {
    currentPage: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    },
    perPageOptions: {
      type: Array,
      required: true
    },
    totalRows: {
      type: Number,
      required: true
    }
  },

  emits: [
    'changeCurrentPage',
    'changePerPage'
  ],

  computed: {

    firstRow () {
      if (this.totalRows === 0) {
        return 0
      }
      return ((this.currentPage - 1) * this.perPage) + 1
    },

    lastRow () {
      let lastRow = this.currentPage * this.perPage
      if (lastRow > this.totalRows) {
        return this.totalRows
      }
      return lastRow
    }
  },

  methods: {

    changeCurrentPage (newCurrentPage) {
      this.$emit('changeCurrentPage', newCurrentPage)
    },

    changePerPage (newPerPage) {
      this.$emit('changePerPage', newPerPage)
    }
  }
}
</script>

<style scoped>

/*** Global composant ***/

.b122-pagination-container {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}

/*** Dropdown perPage ***/

.b122-pagination-container >>> .btn.dropdown-toggle {
  border-radius: var(--main-border-radius);
  font-size: 12px;
}
.b122-pagination-container >>> .dropdown-item {
  font-size: 12px;
}
.b122-pagination-container >>> .current-per-page .dropdown-item {
  font-weight: bolder;
}

/*** Pagination ***/

.b122-pagination-container >>> .page-item:not(.disabled) .page-link {
  color: var(--main-color);
}
.b122-pagination-container >>> .page-item.active .page-link {
  background-color: var(--main-color);
  border-color: var(--main-color);
  color: var(--main-white);
}
.b122-pagination-container >>> .page-item:first-child .page-link {
  border-top-left-radius: var(--main-border-radius);
  border-bottom-left-radius: var(--main-border-radius);
}
.b122-pagination-container >>> .page-item:last-child .page-link {
  border-top-right-radius: var(--main-border-radius);
  border-bottom-right-radius: var(--main-border-radius);
}

</style>



// WEBPACK FOOTER //
// src/components/b122/B122TablePagination.vue